import { SubdirectoryArrowRight } from "@mui/icons-material";

export const HierarchyDisplay = (props: { children: React.ReactNode[] }) => {
  const {
    children: [firstChild, ...children],
  } = props;
  return (
    <div style={{ marginTop: 8 }}>
      {firstChild}
      {children.map((child, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            marginLeft: 24 * (1 + index),
            marginTop: 8,
          }}
        >
          <div style={{ marginRight: 8 }}>
            <SubdirectoryArrowRight />
          </div>
          {child}
        </div>
      ))}
    </div>
  );
};
